import React from 'react';

interface ScoreBarProps {
  score: number | null;
}

const tone = (score: number | null) => {
  if (score == null) return 'bg-slate-500';
  if (score >= 75) return 'bg-emerald-400';
  if (score >= 55) return 'bg-indigo-400';
  if (score >= 40) return 'bg-amber-400';
  return 'bg-rose-400';
};

export const ScoreBar: React.FC<ScoreBarProps> = ({ score }) => {
  const pct = score == null ? 35 : Math.max(0, Math.min(100, score));
  return (
    <div className="h-1.5 w-full rounded-full bg-slate-700/70 overflow-hidden">
      <div className={`h-full ${tone(score)}`} style={{ width: `${pct}%` }} />
    </div>
  );
};
